import { Lightning } from '@lightningjs/sdk';
import Icon from '../icon/icon.component';
import { middle } from '../utils/sizes';
import { BRAND_ICON_WIDTH_RATIO, DEFAULT_ALPHA, LOGO_ICON_SCALE } from './brandIcon.constants';
import { getLogoIcon } from './brandIcon.utils';

export class BrandIcon extends Lightning.Component {
  static _template() {
    return {
      Icon: {
        type: Icon,
        mountY: 0.5,
        alpha: DEFAULT_ALPHA,
        y: middle,
      },
    };
  }

  _construct() {
    this._textureScale = LOGO_ICON_SCALE;
    this._textureWidth = 0;
    this._textureHeight = 0;
  }

  _attach() {
    const icon = this.tag('Icon');
    this._updateWidth = () => {
      this.tag('Icon').setSmooth('alpha', 1);
      this.w = this._textureScale ? Math.round(icon.finalW / this._textureScale) : icon.finalW;
    };
    icon.on('txLoaded', this._updateWidth);
  }

  _active() {
    this._isIconActive = true;
    this._updateIconTexture();
  }

  _inactive() {
    this._isIconActive = false;
  }

  _detach() {
    this.tag('Icon').removeAllListeners('txLoaded');
  }

  get textureScale() {
    return this._textureScale;
  }

  set textureScale(value) {
    this._textureScale = value;
    this._updateIconTexture();
  }

  get w() {
    return super.w;
  }

  set w(value) {
    this.tag('Icon').removeListener('txLoaded', this._updateWidth);
    super.w = value;
    this._textureWidth = value;
    this._updateIconTexture();
  }

  get h() {
    return super.h;
  }

  set h(value) {
    super.h = value;
    if (BRAND_ICON_WIDTH_RATIO) {
      super.w = value * BRAND_ICON_WIDTH_RATIO;
      this._textureWidth = value * BRAND_ICON_WIDTH_RATIO;
    }
    this._textureHeight = value;
    this._updateIconTexture();
  }

  _updateIconTexture() {
    if (!this._isIconActive) {
      return;
    }

    this.tag('Icon').iconData = {
      picto: getLogoIcon(),
      scale: this._textureScale,
      viewBox: {
        w: this._textureWidth,
        h: this._textureHeight,
      },
    };
  }
}
